module.exports = __webpack_public_path__ + "img/app_new_main_1.e3089d91.jpg";